<section class="contact-customer-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="userIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "workobject.ui.contactclient.header" | translate }}
      </div>
    </span>
  </div>
  <div class="contact-customer-mat-dialog-body">
    <div
      class="messages-container flex--r-c gap--8 info m-b--16"
      *ngIf="isContactsEmpty"
    >
      <mat-icon>info</mat-icon>
      {{ "workobject.ui.contactclient.nocontactswarning" | translate }}
    </div>
    <div class="flex--r-s-sb gap--16">
      <div class="contact-person-detail flex-2" *ngIf="!isContactsEmpty">
        <span whFlex="50">
          <div class="contact-person-wrapper">
            <div class="w-h-label html-overflow">
              {{ "workobject.model.contacts" | translate }}
            </div>
            <div class="contact-grid">
              <div *ngFor="let contactDTO of contacts">
                <div class="contact-field flex--row mat-elevation-z1">
                  <span>
                    <i
                      class="workheld-icons p--8 contact-icon"
                      [innerHTML]="contacPersonIcon"
                    ></i>
                  </span>
                  <span class="flex-1">
                    <div
                      style="line-height: 18px; max-width: 300px"
                      class="html-overflow"
                    >
                      <span
                        style="font-weight: bold"
                        matTooltip="{{
                          contactDTO?.firstname
                            ? contactDTO?.firstname + ' ' + contactDTO?.lastname
                            : ''
                        }}"
                      >
                        {{
                          contactDTO?.firstname
                            ? contactDTO?.firstname + " " + contactDTO?.lastname
                            : "-"
                        }}
                      </span>
                    </div>
                    <div style="line-height: 18px" class="html-overflow">
                      <div class="flex--c-fs">
                        <a
                          *ngIf="
                            contactDTO?.countryCodeMobile &&
                            contactDTO?.mobilePhone
                          "
                          href="tel:{{
                            contactDTO?.countryCodeMobile +
                              contactDTO?.mobilePhone
                          }}"
                          >{{
                            contactDTO?.countryCodeMobile +
                              " " +
                              contactDTO?.mobilePhone
                          }}</a
                        >
                        <span
                          *ngIf="
                            !contactDTO?.countryCodeMobile ||
                            !contactDTO?.mobilePhone
                          "
                          >-</span
                        >
                        <a
                          *ngIf="
                            contactDTO?.countryCodeLandLine &&
                            contactDTO?.landLinePhone
                          "
                          href="tel:{{
                            contactDTO?.countryCodeLandLine +
                              contactDTO?.landLinePhone
                          }}"
                          >{{
                            contactDTO?.countryCodeLandLine +
                              " " +
                              contactDTO?.landLinePhone
                          }}</a
                        >
                        <span
                          *ngIf="
                            !contactDTO?.countryCodeLandLine ||
                            !contactDTO?.landLinePhone
                          "
                          >-</span
                        >
                      </div>
                    </div>
                    <div style="line-height: 18px" class="html-overflow">
                      <a
                        *ngIf="contactDTO?.mail"
                        href="mailto:{{ contactDTO?.mail }}"
                        >{{ contactDTO?.mail }}</a
                      >
                      <span *ngIf="!contactDTO?.mail">-</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div style="margin-top: 8px; margin-bottom: 8px">
      <mat-divider class="wh-dialog-divider"></mat-divider>
    </div>
    <form [formGroup]="contactCustomerFormGroup">
      <div fxLayout fxLayoutAlign="left top" fxLayoutGap="20px">
        <div style="padding-top: 6px">
          <mat-form-field whFlex="90">
            <mat-label>{{
              "workobject.model.contactclient.reason" | translate
            }}</mat-label>
            <mat-select formControlName="enumReason" required>
              <mat-option
                *ngFor="let contactReason of ENUMS.CUSTOMER_CONTACT | whenum"
                [value]="contactReason?.id"
              >
                {{ contactReason?.translateKey | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="contactCustomerFormGroup.value.enumReason == 'YES'">
        @if (workOrders.length === 0 || isWithoutWorksteps()) {
          <div class="messages-container flex--r-c gap--8 info m-b--16">
            <mat-icon>info</mat-icon>
            {{
              "technicianNotification.info.noWorkOrderOrWorkstep" | translate
            }}
          </div>
        }
        <div class="select-grid p-t--12">
          <span class="flex-1 column-height">
            <div class="w-h-label html-overflow">
              {{ "workobject.model.contactclient.timeslot" | translate }}
            </div>

            <lib-w-h-datetime-picker
              [parentFormGroup]="tempFormGroup"
              startDateForm="dateSlotForm"
              startTimeForm="timeSlotForm"
              [pastDateAllowed]="false"
              [hasEndDate]="false"
              [futureDate]="true"
              [hasTimer]="true"
              [startDateLabel]="'workobject.model.contactclient.timeslot'"
            ></lib-w-h-datetime-picker>
          </span>

          @if (workOrders.length > 0 && !isWithoutWorksteps()) {
            <span class="flex-1 column-height">
              <div class="w-h-label html-overflow">
                {{
                  "technicianNotification.label.notificationInterval"
                    | translate
                }}
              </div>

              <lib-w-h-dropdown
                class="contact-customer-dropdown"
                [itemKeys]="['displayName']"
                [loading]="
                  contactCustomerFormGroup.disabled ||
                  contactCustomerFormGroup.get('reminderOffsetInMinutes')
                    ?.disabled ||
                  !tempFormGroup.controls['timeSlotForm'].value
                "
                [valueLabel]="'technicianNotification.label.notificationInterval'"
                [value]="'value'"
                [valueFormControl]="
                  contactCustomerFormGroup.get('reminderOffsetInMinutes')
                "
                [dropdownItemDomList]="alertOptions"
              >
              </lib-w-h-dropdown>
            </span>
          }

          <span class="flex-1 flex--c-fs">
            <div
              class="w-h-label header-margin html-overflow"
              style="text-align: center"
            >
              {{ "technicianNotification.label.notificationTime" | translate }}
            </div>

            @if (notificationTimeInfo()) {
              <div class="notification-time" [@dynamicAnimation]="'left'">
                {{
                  notificationTimeInfo() | date: "short" : "" : currentLocale()
                }}
              </div>
            }
          </span>
        </div>

        <mat-error
          *ngIf="
            contactCustomerFormGroup.controls['timeSlot'].invalid ||
            isTimeSlotInvalid
          "
          >{{
            "workobject.model.contactclient.timeslot.error" | translate
          }}</mat-error
        >
      </div>
      <div>
        <mat-form-field whFlex>
          <mat-label>{{
            "workobject.model.contactclient.comment" | translate
          }}</mat-label>
          <textarea
            matInput
            placeholder="{{
              'workobject.model.contactclient.comment' | translate
            }}"
            formControlName="comment"
            [rows]="5"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>
  <w-h-button-group align="end" mat-dialog-actions>
    <w-h-button
      [text]="'app.cancel.label' | translate | uppercase"
      matIcon="close"
      [disabled]="saving"
      (clicked)="cancel()"
    />
    <w-h-button
      [text]="'app.save.label' | translate | uppercase"
      matIcon="save"
      [isLoading]="saving"
      color="accent"
      type="flat"
      [disabled]="
        contactCustomerFormGroup.invalid ||
        contacts === undefined ||
        contacts.length <= 0 ||
        isTimeSlotInvalid ||
        (contactCustomerFormGroup.value.enumReason == 'YES' &&
          workOrders.length === 0)
      "
      (clicked)="createLogAndUpdateWorkObject()"
    />
  </w-h-button-group>
</section>
